import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../Home/Home.css';
import Navbar from '../Common/Navbar';
import homebanner from '../../Assets/Banner/homebanner.mp4';

const services = [
  'Tax Consulting',
  'Rental Property HST Rebates',
  'Bookkeeping Services',
  'Auditing',
  'Taxes',
  'Payroll Management',
  'Business Registration',
  'Tax Planning and Reporting',
  'Loans & Mortgages',
  'Legally Required',
  'Strategic HR Consulting',
  'IT Services Partnering',
];

const Banner = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="home_container home-banner">
        <video autoPlay muted loop playsInline className="home_video">
          <source src={homebanner} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="home_bg">
          <Navbar />
          <div className="home_head_container container">
            <div className="home_content">
              <h2 data-aos="fade-up">
                Leading Tax Consultant &amp; Business Services
              </h2>

              <p className="p1" data-aos="fade-up">
                Welcome to Oriental Business Solutions &mdash; comprehensive
                financial &amp; business solutions.
              </p>

              <div className="banner__cta-row" data-aos="fade-up">
                <button
                  className="btn cta-btn banner__cta banner__cta--primary"
                  onClick={() => navigate('/contact')}
                >
                  Get Started Now
                </button>
                <button
                  className="btn cta-btn banner__cta banner__cta--secondary"
                  onClick={() => navigate('/about')}
                >
                  Learn More
                </button>
              </div>

              <div className="home_note banner__seal" data-aos="fade-up">
                <span className="banner__seal-label">CRA Certified</span>
                <p className="p1">
                  Approved Free Tax Clinic &mdash; Community Volunteer Income
                  Tax Programme (CVITP)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scrolling services ticker — separate strip below the banner */}
      <div className="banner__ticker">
        <span className="banner__ticker-label">Our Tax Services</span>
        <div className="banner__ticker-track">
          <div className="banner__ticker-group">
            {services.map((item, i) => (
              <span className="banner__ticker-item" key={`a-${i}`}>
                {item}
              </span>
            ))}
          </div>
          <div className="banner__ticker-group" aria-hidden="true">
            {services.map((item, i) => (
              <span className="banner__ticker-item" key={`b-${i}`}>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;